import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Select as MuiSelect } from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

interface SelectProps {
	containerStyles?: CSSProperties;
	fullWidth?: boolean;
	labelStyles?: CSSProperties;
	options: { label: string; value: string }[];
	placeholder: string;
	selectInputStyles?: CSSProperties;
	selectLabel: string;
	setValue: (a: string) => void;
	value: string;
	width?: string | number;
}

const WhiteExpandMore = (props: any) => {
	return (
		<ExpandMore
			style={{ color: '#FFFFFF', pointerEvents: 'none' }}
			{...props}
		/>
	);
};

const Select = ({
	containerStyles = {},
	fullWidth = true,
	labelStyles = {},
	options,
	placeholder,
	selectInputStyles = {},
	selectLabel,
	setValue,
	value,
	width = 150,
}: SelectProps) => {
	const handleChange = (event: SelectChangeEvent) => {
		setValue(event.target.value);
	};

	return (
		<Box
			sx={{
				minWidth: 100,
				width: width,
				...containerStyles,
			}}
		>
			<FormControl variant="filled" fullWidth={fullWidth} size="small">
				<InputLabel
					id="select-label"
					sx={{ ...labelStyles }}
					focused={false}
				>
					{selectLabel}
				</InputLabel>
				<MuiSelect
					labelId="select-label"
					id="select"
					IconComponent={WhiteExpandMore}
					value={value}
					label={selectLabel}
					onChange={handleChange}
					sx={{
						...selectInputStyles,
					}}
				>
					<MenuItem disabled value="">
						<em>{placeholder}</em>
					</MenuItem>
					{options.map(({ label, value }) => (
						<MenuItem key={`${label}-${value}`} value={value}>
							{label}
						</MenuItem>
					))}
				</MuiSelect>
			</FormControl>
		</Box>
	);
};

export default Select;
